import noop from 'lodash/noop';
import { FC } from 'react';
import { Checkbox, CHECKBOX_STATUS } from 'ui/checkbox';
import { colors } from 'ui/theme';

import { channelSelectOptionsId } from './ChannelOpt.constants';
import { ChannelText, OptionsContainer, OptionsRow } from './ChannelOptionsSelector.styled';
import { ChannelOptionsSelectorProps } from './types';

export const getChannelOptionsCheckboxTestId = (id: string) => `channel-options-checkbox-${id}`;

export const ChannelOptionsSelector: FC<React.PropsWithChildren<ChannelOptionsSelectorProps>> = (
  props,
) => {
  const { config = [], onSelection = noop, isDisabled = false } = props;
  return (
    <OptionsContainer data-test={channelSelectOptionsId}>
      {config.map(({ id, icon: Icon, isChecked, text }) => (
        <OptionsRow key={`${text}-${id}`}>
          {Icon && <Icon color={colors.cyan100} />}
          <ChannelText>{text}</ChannelText>
          <Checkbox
            status={isChecked ? CHECKBOX_STATUS.CHECKED : CHECKBOX_STATUS.UNCHECKED}
            onClick={() => onSelection(id)}
            data-test={getChannelOptionsCheckboxTestId(id)}
            isDisabled={isDisabled}
          />
        </OptionsRow>
      ))}
    </OptionsContainer>
  );
};
